module.exports = __webpack_public_path__ + "assets/img/GFJSBg.2e77f059.png";